

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import { CloseCircleOutlined } from '@ant-design/icons';
import GoodsCardDialog from '../dialog/goods-card';
import can from '../../../../components/ability';


export default (props) => {
    
    const { value, onChange, schema } = props;
    const { multi = true } = schema;
    const [showChoose, setShowChoose] = useState(false);
    const [list, setList] = useState([]);
    const globalConfig = useContext(FormConfigContext);
    const { accId, shopId } = globalConfig;


    const getList = async () => {
        const response = await fetch(`/api/goods-card/list?shopId=${shopId}`);
        const result = await response.json();

        if(result?.success) {
            return result?.data?.rows.filter(i => i.status === 1);
        }else{
            return [];
        }
    };
    function clearValue(e) {
        e.stopPropagation()
        onChange();
    }
    useEffect(() => {
        getList().then(res => setList(res));
        return;
    }, []);

    const showList = [];
    let forList = value || [];
    if (!Array.isArray(forList)) {
        forList=[value]
    }
    forList.forEach(v => {
        let find = list.find(i => i.cardTmpId === v);
        if (find) {
            showList.push(find)
            return;
        }
    })
    
    return (
        <div className='comp-form-customer-field'>
            <GoodsCardDialog
                visible={showChoose}
                onClose={() => setShowChoose(false)}
                onChange={(value) => {onChange(multi?value: value[0]); setShowChoose(false);}}
                multi={multi}
                value={showList.map(i => i.cardTmpId)}
                list={list}
            />
            <div className={`comp-form-choose-item ${showList.length > 0 ?'':'empty'}`} onClick={() => setShowChoose(true)}>
                {
                    showList.map(i => i.title).join(', ') || '点击选择次卡'
                }
                <CloseCircleOutlined className='clear-value' onClick={clearValue} />
            </div>
        </div>
    );
};